<!-- 多选老师 -->
<template>
  <el-form-item :label="label" class="special-item">
    <el-select v-model="teacherType" clearable class="special-select-one"  :placeholder="' '" @change="typeChange">
      <el-option v-for="item in typeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
    </el-select>
    <el-select v-model="teacherSelectedList" v-show="!hasPerson" class="special-select-two"  @change="teacherChange"
      :multiple="true" :placeholder="config.placeholder" :clearable="true"
      filterable :filter-method="getTeacherList" collapse-tags collapse-tags-tooltip :max-collapse-tags="1" @visible-change="loseFocus">
      <el-option v-for="item in teacherList" :label="item.name" :value="item.id" :key="item.id"></el-option>
    </el-select>
    <el-select disabled v-show="hasPerson" class="special-select-two" :placeholder="config.placeholder" :clearable="true">
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-有无跟进老师多选',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          placeholder: '请选择',
        };
      },
    },
    label: {
      type: String,
      default: '老师：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const api = inject('api');
    const teacherList = ref([]);
    const teacherType = ref();
    const typeList = ref([{
      id: 0,
      name: '无',
    }, {
      id: 1,
      name: '有',
    }]);
    let teacherSelectedList = ref('');

    async function getTeacherList(queStr) {
      const res = await api.allTeacherList({
        scene: 0,
        queryKey: queStr || '',
      });
      teacherList.value = res.data;
    }
    const hasPerson = ref(true);
    getTeacherList();

    function reset() {
      teacherType.value = '';
      hasPerson.value = true;
      teacherSelectedList.value = props.value.map((v) => v.id);
    }

    teacherSelectedList = useQuery('teacherMulti', props.value, reset);
    const typeChange = (v) => {
      hasPerson.value = v !== 1;
      teacherSelectedList.value = '';
      if (!v) {
        teacherSelectedList.value = v === 0 ? null : undefined;
      }
    };

    const teacherChange = (v) => {
      if (v.length === 0) {
        teacherSelectedList.value = '';
      }
    };

    return {
      child,
      teacherList,
      typeChange,
      teacherType,
      typeList,
      hasPerson,
      teacherSelectedList,
      teacherChange,
      getTeacherList,
      loseFocus(val) {
        // 下拉框隐藏时重新刷新一下老师列表，否则还是展示之前的搜索结果
        if (!val) {
          getTeacherList('');
        }
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.special-select-one{
  :deep(.el-input){
    width:57px !important;
  }
}
.special-select-two{
  :deep(.el-input){
    width:165px !important;
  }
}
</style>
<style lang="scss">
.special-item {
  .special-select-two{
    .el-select__tags-text {
      display: inline-block;
      max-width: 36px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
